import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=209f24d0&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f24d0",
  null
  
)

export default component.exports